import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from '@angular-monorepo/environment';

@Injectable({
  providedIn: 'root',
})
export class BrebService {
  private get baseUrl(): string {
    return this.environmentService.env.apiConfig.payinCheckoutBackendUrl;
  }

  constructor(
    private environmentService: EnvironmentService,
    private http: HttpClient
  ) {}

  getOperation(transactionId: string, verification: string): Observable<any> {
    const headers = new HttpHeaders({
      verification,
    });

    return this.http.post<any>(
      `${this.baseUrl}common/operation/find/${transactionId}`,
      {},
      { headers }
    );
  }

  createBankTransfer(operationId: number | string, verification: string): Observable<any> {
    const headers = new HttpHeaders({
      verification,
    });

    return this.http.post<any>(
      `${this.baseUrl}processor/breb/operation-checkout/banktransfer/create/${operationId}`,
      {},
      { headers }
    );
  }

  createQr(operationId: number | string, verification: string): Observable<any> {
    const headers = new HttpHeaders({
      verification,
    });

    return this.http.post<any>(
      `${this.baseUrl}processor/breb/operation-checkout/qr/create/${operationId}`,
      {},
      { headers }
    );
  }
}
